var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-selector"},[_c('input',{staticClass:"step-selector",attrs:{"id":'rd-step' + _vm.step,"name":"current_step","type":"radio"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change')}}}),_c('label',{attrs:{"for":'rd-step' + _vm.step}})])
}
var staticRenderFns = []

export { render, staticRenderFns }